import * as type from './constant';

export const getWorkUnit = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getWorkUnitSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getWorkUnitError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addWorkUnit = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addWorkUnitSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateWorkUnit = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateWorkUnitSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteWorkUnit = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteWorkUnitSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationWorkUnitError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
